module.exports = __webpack_public_path__ + "img/brainhealth-logo.f556f4f3.png";